import zhLocale from 'element-ui/lib/locale/lang/zh-CN'
const cn = {
  Layout: {
    'cart': '购物车',
    'navList': ["首页", "商城", "陈列馆", "新闻", "联系我们"],
    'shopList': ['活动商城', '全价区', '半价区'],
    'contactList': ['加入我们', '在线留言'],
    'logOut': '注销',
    'logIn': '登录',
    'register': '注册',
    'message': '消息',
    'myOrders': '我的订单',
    'myFavor': '我的收藏',
    'currentLan': '简体中文',
    'cartGoods': '件商品',
    'cartGoodsTotal': '共',
    'cartPrice': '共计',
    'buy': '结算',
    'cartEmpty': '购物车空空如也~',
    'messageEmpty':'暂无消息喔~'
  },
  HomePage: {
    'titleList': ['陈列馆', '热门销售']
  },
  Shop: {
    'search': '搜索',
    'fullPrice': '全价区',
    'halfPrice': '半价区',
    'scale': '比例',
    'status': '状态',
    'scaleList': ['全部比例', '1/1', '1/12', '1/18', '1/43', '1/64', '1/87'],
    // 'statusList': ['全部', '预售中', '热卖中', '补款中', '已截单', '即将开售', '已售罄'],
    'statusList': [{ id: '', name: '全部' }, { id: '20', name: '预售中' }, { id: '10', name: '热卖中' }, { id: '30', name: ' 补款中' }, { id: '40', name: '已截单' }, { id: '50', name: '即将开售' }, { id: '60', name: '已售罄' }],
  },
  News: {
    'newsType': [{ id: '0', name: '全部' }, { id: '1', name: '品牌新闻' }, { id: '2', name: '产品新闻' }, { id: '3', name: '活动新闻' }],
    'checkDetails': '查看详情',
    'pages': ['共', '页', '条信息']
  },
  Contact: {
    'titleName': ['加入我们', '在线留言', '联系方式'],
    'button': '提交',
    'placeholders': ['你的名字', '你的姓氏', '你的性别', '求职岗位', '联系方式', '你的邮箱', '问题类型', '留言内容', '上传附件（小于2M）'],
    'typeList': [{ id: '0', name: '问题咨询' }, { id: '1', name: '售后反馈' }, { id: '2', name: '建议投诉' }],
    'social': [
      { imgUrl: "static/img/wem.png", name: "Facebook" },
      { imgUrl: "static/img/wem.png", name: "微信" },
      { imgUrl: "static/img/wem.png", name: "新浪微博" },
      { imgUrl: "static/img/wem.png", name: "微信商城" }
    ],
    'info': [
      { name: "电话", val: "400-8818-792" },
      { name: "粉丝页面", val: "www.facebook.com/kingartshk" },
      { name: "微博", val: "weibo.com/u/3906268664" },
      { name: "微信公众号", val: "KingArtsHK" },
      { name: "电子邮件", val: "info@guanxingroup.com" },
      { name: "网站", val: "www.king-arts.com" },
      { name: "公司地址", val: "香港皇后大道中181号新纪元广场1501室" }
    ]
  },
  Personal: {
    'optionList': ['个人资料', '会员身份', '修改密码', '我的订单', '我的收藏', '我的购物车'],
    'formTtile': ['姓名', '性别', '电话', '邮箱', '邮编', '操作', '已保存收货地址', '收货人', '地址', '编辑', '删除', '新建地址'],
    'dialogTitle': ['修改个人资料', '新增收货地址', '修改收货地址'],
    'del': '是否删除当前地址',
    'tips': ['编辑资料成功', '新增地址成功', '删除成功', '修改地址成功'],
    'sexList': [{ id: '0', name: '男' }, { id: '1', name: '女' }],
    'placeholders': ['请输入姓名', '性别', '请输入电话号码', '请输入邮箱地址', '请输入收件人姓名', '请输入收件人联系方式', '请选择大洲', '请选择国家', '请输入详细地址（包含省/市/街道）', '请输入邮政编码']
  },
  Member: {
    'title': ['我的等级', '积分规则及会员优惠'],
    'levels': ['普通会员', '白银会员', '黄金会员', '钻石会员'],
    'coupon': ['0折', '9.5折', '9折', '8折'],
    'tables': ['当前会员等级', '积分数量', '享受折扣数'],
    'hints': ['您还差', '分就晋升为', '，将可以享受', '%优惠'],
    'diamond': ['您已成为', '可享受'],
    'note': ['购物增加积分', '一个月没有进行消费'],
    'rule': '用户在登陆注册自动成为普通会员，默认等级为0，不享受任何折扣，用户每消费一元就获得一个积分，用户积分达到1000分时（或指定分数），会员等级升为白银会员，可享受9.5折（或指定折扣）优惠，用户积分达到5000分时（或指定分数），会员等级升为黄金会员。可享受9折（或指定折扣）优惠，用户积分达到10000分时（或指定分数），会员等级升为钻石会员，可享受8折优惠（或指定折扣）。如果用户一个月（从下单日开始计算）不产生消费记录，用户积分减少500分，用户低于500分时再次减少归零，不再减少。'
  },
  changePass: {
    'title': ['原密码', '新密码', '再次确认密码'],
    'placeholders': ['请输入原密码', '请输入8-20位字母+数字密码', '请再次输入新密码'],
    'error': ['请输入密码', '请输入正确格式的密码', '请再次输入密码', '两次输入密码不一致！'],
    'tips': '修改密码成功'
  },
  favor: {
    'cancel': '取消收藏',
    'tips': '取消收藏成功',
    'dialog': ['是否取消收藏该商品？', '取消', '确认']
  },
  cart: {
    'table': ['商品信息', '单价', '数量', '会员优惠', '小计', '操作'],
    'dialog': ['是否删除该商品？', '取消', '确认'],
    'oper': ['加入收藏夹', '删除'],
    'bottom': ['已选商品', '件 合计（不含运费）', '结算']
  },
  login: {
    'title': '登录',
    'tips': '登录成功',
    'placeholders': ['邮箱账号', '请输入密码'],
    'oper': ['注册', '忘记密码？']
  },
  regis: {
    'title': ['账号', '验证码', '密码', '确认密码', '已有账号？去'],
    'oper': ['获取验证码', '注册', '用户勾选代表同意', '《冠霆服务条款》'],
    'placeholders': '请输入4位验证码',
    'codetext': ['获取验证码', '发送中...', '秒重新获取'],
    'error': ['请输入邮箱', '请输入正确的邮箱', '请输入验证码', '请同意相关条款'],
    'tips': ['注册成功', '验证码发送成功，请注意查收']
  },
  pay: {
    'title': ['选择支付方式', '交易号', '实付', '支付方式', '立即支付'],
    'hints': '请打开微信支付'
  },
  recovery: {
    'title': ['忘记密码'],
    'tips': '重置密码成功'
  },
  orders: {
    'tabs': [{ id: '0', name: '所有订单' }, { id: '1', name: '待支付' }, { id: '2', name: '待发货' }, { id: '3', name: '待收货' }, { id: '4', name: '待评价' }],
    // 'tabs': ['所有订单', '待支付', '待发货', '待收货', '待评价'],
    'time': '下单时间',
    'oper': ['查看物流', '含运费', '去支付', '取消订单', '查看详情']
  },
  logi: {
    'title': ['物流详情', '物流单号', '物流公司']
  },
  details: {
    'title': ['数量', '详情', '评价'],
    'oper': ['分享', '收藏', '立即购买', '加入购物车'],
    'list':['定金','预售截止日期','请在','前补齐尾款','库存','已售罄']
  },
  checkorder: {
    'title': ['订单编号', '下单时间', '商品详情',],
    'innerTitle': ['收货人信息', '收货人', '联系方式', '收货地址', '商品总金额', '运送地区', '快递公司', '运费', '应付总额'],
    'oper': ['取消订单', '付款'],
    'label': ['商品信息', '单价', '数量', '会员优惠', '小计', '成交价格']
  },
  submitorder: {
    'title': ['选择收货地址', '管理收货地址', '确认订单信息', '备注信息', '提交订单'],
    'hints': ['温馨提示', '您购物已满', '是否前往半价区进行挑选', '好的', '算了'],
    'half': ['半价区', '请在以下半价商品中挑选一件', '半价商品信息']
  },
  comment: {
    'title': '与描述是否相符',
    'placeholders': '说说你的感受吧'
  },
  public: {
    "regisbtn":'注册',
    'annouce': '公告',
    'more': '更多',
    'confirm': '确定',
    'cancel': '取消',
    'sex': ['男', '女'],
    'prev': '上一页',
    'next': '下一页',
    'loginstatus': '尚未登录',
    'noitem':'购物车空空如也~',
    'money':'￥'
  },
  newword:{
    'new1':'请选择一样商品',
    'new2':'加入收藏成功',
    'new3':'移除购物车成功',
    'new4':'评价成功',
    'new5':'加入购物车成功',
    'new6':'取消订单成功',
    'new7':'是否确认收货?',
    'new8':'是否取消订单?',
    'new9':'请输入验证码',
    'new10':'确认删除订单?'
  }
}

export default cn;


// WEBPACK FOOTER //
// ./src/i18n/langs/cn.js